<template>
    <popup-modal ref="popup">
        <h2 class="font-bold mb-4 text-xl">{{ title }}</h2>
        <div class="mb-4">{{ message }}</div>

        <formcontrol
                autofocus
                ref="channel"
                type="dropdown"
                class="mb-2"
                v-model="form.channel_id"
                :options="options"
        ></formcontrol>

        <textarea
                ref="reason"
                v-model="form.reason"
                class="w-full h-20 input mb-4 focus:outline-none bg-white/10"
                placeholder="Укажите причину переноса"
        ></textarea>

        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click.prevent="_cancel">{{ cancelButton }}</button>
            <button class="btn btn-md btn-primary" @click.prevent="_confirm">{{ okButton }}</button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from './PopupModal.vue'
import Textarea from "../form/textarea";
import Formcontrol from "../form/formcontrol";
import Client from "../../js/modules/Client";
import Plural from "../../js/modules/Plural";

export default {
	name: 'MovePostDialog',

	components: {Formcontrol, Textarea, PopupModal},

	data: () => ({
		title: undefined,
		message: undefined,
		okButton: undefined,
		cancelButton: 'Отмена',
		isPrompt: false,
		options: [],
		author: undefined,

		subWords: ['подписчик', 'подпискиаа', 'подписчиков'],

		form: {
			channel_id: 0,
			reason: '',
		},
	}),

	mounted() {
		this.loadChannels();
	},

	methods: {
		loadChannels() {
			Client.get('/api/v1.1/channel/list?conditions[]=visibleOnly&conditions[]=withSubscribersCount')
				.then(response => {
					this.options = response.data.data.map(item => ({
						value: item.id,
						label: item.name,
						description: Plural(Number(item.subscribers_count), this.subWords),
						img: item.ava
					}));
				});
		},
		show(opts = {}) {
			this.title = opts.title
			this.message = opts.message
			this.okButton = opts.okButton
			this.isPrompt = opts.isPrompt ?? false;
			this.form.channel_id = opts.channel_id || 0;
			this.author = opts.author ?? null;

			if (this.author) {
				this.options = [
					{
						value: 0,
						label: 'Блог пользователя',
						description: Plural(Number(this.author.subscribers_count), this.subWords),
						img: this.author.ava,
					},
					...this.options,
				];
			}

			if (opts.cancelButton) {
				this.cancelButton = opts.cancelButton;
			}

			this.$refs.popup.open();

			setTimeout(() => this.$refs.channel.$refs.dropdown.activate(), 100);

			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		_confirm() {
			this.$refs.popup.close();
			this.resolvePromise(this.form);
		},

		_cancel() {
			this.$refs.popup.close()
		},
	},
}
</script>
